import _ from 'classnames';
import React from 'react';
import styles from "./DataGridRow.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function DataGridRowSkeleton({
  children,
  rowAlternating
}) {
  return /*#__PURE__*/_jsx("div", {
    className: _(rowAlternating && styles.rowAlternating, styles.dataGridRow),
    children: children
  });
}